export default __webpack_public_path__ + "static/media/dhs_seal.b2a75fc1.svg";